import React from 'react';
import { inject } from 'mobx-react';
import Container from './Container';

export default inject('page')(({ page }) => (
  <Container>
    <div>{page.address.address1}</div>
    {page.address.address2 && <div>{page.address.address2}</div>}
    <div>
      {page.address.city} {page.address.state}, {page.address.zip}
    </div>
  </Container>
));
